import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@getgo/chameleon-web-react-wrapper';

import st from 'utils/shared-translations';

import './direct-debit-sepa-header.css';

const DirectDebitSepaHeader: FC = (): JSX.Element => {
  const intl = useIntl();

  return (
    <header className="direct-debit-sepa-header">
      <section className="direct-debit-sepa-header__label">
        <Typography tag="h1" variant="heading-medium">
          {intl.formatMessage(st['dd.form.header'])}
        </Typography>
      </section>
      <Typography variant="body-small">{intl.formatMessage(st['dd.form.header.sepa.caption'])}</Typography>
    </header>
  );
};

export default DirectDebitSepaHeader;
